import axios from "axios";
import {host} from "../config/host"


export const loginUser = (email, password) => async (dispatch) => {
  try {
    dispatch({
      type: "LoginRequest",
    });

    const { data } = await axios.post(
      `${host}/api/v1/user/login`,
      { email, password },{withCredntials: true,
        credentials: 'include'
},
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    dispatch({
      type: "LoginSuccess",
      payload: data.user,
    });
  } catch (error) {
    dispatch({
      type: "LoginFailure",
      payload: error.response.data.message,
    });
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    dispatch({
      type: "LogoutUserRequest",
    });

    await axios.post(`${host}/api/v1/user/logout`);

    dispatch({
      type: "LogoutUserSuccess",
    });
  } catch (error) {
    dispatch({
      type: "LogoutUserFailure",
      payload: "error"  
    });
  }
};

export const getUser = () => async (dispatch) => {
  try {
    dispatch({
      type: "GetUserRequest",
    });

    const { data } = await axios.get(`${host}/api/v1/user/account`);

    dispatch({
      type: "GetUserSuccess",
      payload: data.user,
    });
  } catch (error) {
    dispatch({
      type: "GetUserFailure",
      payload: error.response.data.message,
    });
  }
}
